import { LoggerConfig } from ".";
import os from "os";

export function loadLoggerConfig(): LoggerConfig {
	return createLoggerConfig();
}

function createLoggerConfig(): LoggerConfig {
	const baseConfig: LoggerConfig = {
		outputType: "machine",
		level: "debug",
		logServiceDisabled: false,
		serviceName: process.env.APP_NAME || "consumer-web",
		hostName: process.env.HOSTNAME || os.hostname() || "unknown-host"
	};

	switch (process.env.LOG_LEVEL) {
		case "debug":
		case "info":
		case "verbose":
			return {
				...baseConfig,
				level: process.env.LOG_LEVEL
			};
		default:
			return baseConfig;
	}
}
